import dataLayerPush from "@magalu/ecomm-components/rave/events/GA/utils/dataLayerPush";

export const gateKeeperButtonClick = dataLayerPush(() => ({
  event: "clickEvent",
  eventAction: "click",
  eventCategory: "porteiro",
  eventLabel: "cta",
  eventNonInteraction: 0,
}));
